import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

type AssetType = "truck" | "trailer";

interface TruckStatusDto {
  truckId: string;
  unitNumber: string;
  status: string;
  authorityCompanyId: string;
  authorityCompanyName: string;
  transactionType: string;
}

interface TrailerStatusDto {
  trailerId: string;
  unitNumber: string;
  status: string;
  authorityCompanyId: string;
  authorityCompanyName: string;
  transactionType: string;
}

interface OthersBreakdownDto {
  authorityCompanyId: string;
  authorityCompanyName: string;
  transactionType: string;
  count: number;
}

type DrillDownData =
  | TruckStatusDto[]
  | TrailerStatusDto[]
  | OthersBreakdownDto[];

const DetailsList: React.FC<{ data: DrillDownData; asset: AssetType }> = ({
  data,
  asset,
}) => {
  const navigate = useNavigate();

  if (!data || !Array.isArray(data) || data.length === 0)
    return <Typography>No data found.</Typography>;

  const first = data[0] as any;
  const isBreakdown = first?.count !== undefined;
  if (isBreakdown) {
    const list = data as OthersBreakdownDto[];
    return (
      <>
        <Typography variant="subtitle1">
          Breakdown for “Others” — {list[0].transactionType}
        </Typography>
        <List>
          {list.map((item) => (
            <ListItem disablePadding key={item.authorityCompanyId}>
              <ListItemButton
                sx={{ borderBottom: "1px solid #ccc" }}
                onClick={() =>
                  navigate(
                    `/rental/companies?search=${encodeURIComponent(
                      item.authorityCompanyName,
                    )}`,
                  )
                }
              >
                <ListItemText
                  primary={item.authorityCompanyName}
                  secondary={`Count: ${item.count}`}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </>
    );
  }

  return (
    <List>
      {(data as any[]).map((itm) => (
        <ListItem
          disablePadding
          key={asset === "truck" ? itm.truckId : itm.trailerId}
        >
          <ListItemButton
            sx={{ borderBottom: "1px solid #ccc" }}
            onClick={() => {
              if (asset === "truck" || itm.truckId) {
                navigate(`/fleet/assets/truck/${itm.truckId}`);
              } else {
                navigate(`/fleet/assets/trailer/${itm.trailerId}`);
              }
            }}
          >
            <ListItemText
              primary={`Unit: ${itm.unitNumber}, Status: ${itm.status}`}
              secondary={`TransactionType: ${itm.transactionType}`}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default DetailsList;
